import * as React from 'react';
import '../../styles/LoadingOverlay.css';

export interface Props {
    show: boolean | undefined;
    inBootstrapColumn: boolean;
}

const LoadingSpinner = () => (
    <div className="spinner">
        <div className="rect1" />
        <div className="rect2" />
        <div className="rect3" />
        <div className="rect4" />
        <div className="rect5" />
    </div>
);

export const LoadingDisplay = () => (
    <div className="flex-centered">
        <LoadingSpinner />
    </div>
);

// NOTE: In order to use the LoadingOverlay component make sure that
//       the parent component is using position:relative
function LoadingOverlay({ show, inBootstrapColumn }: Props) {
    return show ? (
        <div
            className={
                'loading-overlay flex-centered' + (inBootstrapColumn ? ' column-offset' : '')
            }
        >
            <LoadingSpinner />
        </div>
    ) : null;
}

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/common/LoadingOverlay.tsx